import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
import css from './index.module.css';

import SEO from "@components/seo";
import MainContent from "@components/content";
import MiniProduct from "@components/miniProduct";

import * as Types from '../../types';
import Search from "@components/search";
import { useScrollSave } from "@hooks/useScrollSave";

export default function SearchPage() {
  const { query } = useParams();
  const [products, setProducts] = useState<Types.Product[]>();

  const { restoredData, isRestored, updateScrollY } = useScrollSave(
    `search_scroll_${query}`,
    { products },
    products && products.length > 0
  );

  useEffect(() => {
    if (restoredData) {
      setProducts(restoredData.products);
    }
  }, [restoredData]);
  
  useEffect(() => {
    if (isRestored.current) {
      isRestored.current = false;
      return;
    }

    axios.get(`${import.meta.env.VITE_API_URL}/search?query=${query}`, {
      headers: {
        'Content-Type': 'application/json',
      }
    }).then(response => {
      setProducts(response.data);
    }).catch(error => {
      console.log(`Error fetch products: ${error}`)
    });
  }, [query]);

  useEffect(() => {
    const container = document.getElementById('scrollable-content');
    if (container) {
      container.addEventListener('scroll', updateScrollY);
    }
    return () => {
      if (container) {
        container.removeEventListener('scroll', updateScrollY);
      }
    };
  }, [updateScrollY]);
  
  useEffect(() => {
    if (isRestored.current) {
      isRestored.current = false;
      return;
    }

    axios.get(`${import.meta.env.VITE_API_URL}/search?query=${query}`, {
      headers: {
        'Content-Type': 'application/json',
      }
    }).then(response => {
      setProducts(response.data);
    }).catch(error => {
      console.log(`Error fetch products: ${error}`)
    });
  }, [query]);

  return (
    <MainContent header={`n`}>    
      <SEO 
        title={`${query}`}
        description={`Поисковой запрос: ${query}`}
        ogUrl={`https://рыбныимир.рф`}
      /> 

      <div className={css.header}>
        <h1>{query}</h1>
        <Search />
      </div>
      
      <div className={css.productList}>
        {products?.map((product: Types.Product) => (
          <MiniProduct 
            id={product.id}
            product={product}
            title={product.name}
            price={product.price}
            image={product.images[0]}
            unit={product.unit}
            quantity={product.quantity}
          />
        ))}
      </div>
    </MainContent>
  )
}